/** What each permission module is called on screen; nav labels where the module has a page. */
export const SCREEN_NAMES: Readonly<Record<string, string>> = {
  account: 'Accounts',
  accountingIntegration: 'Accounting Integration',
  accountOnboarding: 'Account Onboarding',
  accountsPayable: 'Accounts Payable',
  accountsReceivable: 'Accounts Receivable',
  auditLog: 'Audit Trail',
  bom: 'Bill of Materials',
  brand: 'Brands',
  calendar: 'Calendar',
  cannabisCompliance: 'Cannabis Compliance',
  carrier: 'Carriers',
  commission: 'Commissions',
  company: 'Company Setup',
  contact: 'Contacts',
  currency: 'Currencies',
  customer: 'Customers',
  department: 'Departments',
  event: 'Events',
  importsExport: 'Imports & Exports',
  inventory: 'Inventory',
  invoice: 'Invoices',
  leafLinkIntegration: 'LeafLink',
  location: 'Locations',
  locationGroup: 'Warehouses',
  manufactureOrder: 'Manufacturing',
  media: 'Media',
  part: 'Parts',
  payment: 'Payments',
  paymentTerms: 'Payment Terms',
  picking: 'Picking',
  pricingEngine: 'Pricing',
  pricingRule: 'Pricing Rules',
  product: 'Products',
  promotion: 'Credits',
  purchaseOrder: 'Purchase Orders',
  receiving: 'Receiving',
  reports: 'Custom Reports',
  rma: 'Supplier Returns',
  salesOrder: 'Sales Orders',
  settings: 'Settings',
  shipping: 'Shipping',
  strain: 'Strains',
  task: 'Tasks',
  taxRate: 'Tax Rates',
  transferOrder: 'Transfer Orders',
  uom: 'Units of Measure',
  user: 'Users',
  userGroup: 'Roles',
  vendor: 'Vendors',
  workOrder: 'Work Orders',
};
